// import React, { useState } from "react";
import React from 'react'

import { useForm } from "react-hook-form";
import { sponsorAdmin } from "../../../data";


const LiveAccountForm = () => {
    const { register, handleSubmit } = useForm();
    // const [data, setData] = useState("");
    const { name, account } = sponsorAdmin;

    const onSubmit = () => {
        alert('submitted');
    }




    return (

        <div className='flex flex-col lg:flex-row lg:gap-x-[30px] gap-y-[30px] lg:gap-y-0 justify-center items-center mt-5' >
            <form className='flex flex-col mb gap-x-[10px] w-[200px] lg:w-[400px]' id="live" onSubmit={handleSubmit((onSubmit))}>
                <select className="p-[7px] flex border bg-transparent border-dark rounded-lg w-full h-full pl-6   text-black mb-5 font-primary"{...register("category", { required: true })} required>
                    {name.map((index) => (<option key={index}className=' font-primary' value={index}>{`${index === '' ? 'Select Admin' : index}`}</option>))
                    }
                </select>
                <input className=' p-[7px] flex border border-dark rounded-lg w-[full] h-full pl-6   placeholder:text-dark text-black mb-5' {...register("firstName")} placeholder="First name" type='text' required />
                <input className=' p-[7px] flex border border-dark rounded-lg w-full h-full pl-6   placeholder:text-dark text-black mb-5' {...register("lastName")} placeholder="Last name" type='text' required />
                <input className=' p-[7px] flex border border-dark rounded-lg w-full h-full pl-6   placeholder:text-dark text-black mb-5' {...register("email")} placeholder="Email" type='email' required />
                <input className=' p-[7px] flex border border-dark rounded-lg w-full h-full pl-6   placeholder:text-dark text-black mb-5' {...register("broker")} placeholder="Broker" type='text' required />
                <input className=' p-[7px] flex border border-dark rounded-lg w-full h-full pl-6   placeholder:text-dark text-black mb-5' {...register("mtnum")} placeholder="MT4#/MT5#" type='number' required />
                <select className="p-[7px] flex border bg-transparent border-dark rounded-lg w-full h-full pl-6   placeholder:text-dark text-black mb-5 font-primary" {...register("category", { required: true })} required>
                    <option value=''>MetaTrader Platform</option>
                    <option value='MT4'>MT4</option>
                    <option value='MT5'>MT5</option>
                </select>
                <select className="p-[7px] flex border bg-transparent border-dark rounded-lg w-full h-full pl-6   placeholder:text-dark text-black mb-5 font-primary" {...register("category", { required: true })} required>
                    {account.map((index1) => (<option key={index1} value={index1}>{`${index1 === '' ? 'Select Account type' : index1}`}</option>))}
                </select>
                <input className=' p-[7px] flex border border-dark rounded-lg w-full h-full pl-6   placeholder:text-dark text-black mb-5' {...register("amountFunded")} placeholder="Amount Funded ($)" required />

                {/* <textarea {...register("aboutYou")} placeholder="About you" /> */}

                <button type="submit" className="btn btn-sm space-x-[14px] items-center bg-sky-400  hover:bg-sky-300 hover:text-white justify-center">Submit</button>

            </form>
            {/* <p className="text-black">test</p> */}

        </div>


    );
}
export default LiveAccountForm;
